const LIST_URL = "/v1/slider/list";
const SINGLE_URL = "/v1/slider/single";
const ADD_URL = "/v1/slider/add";
const UPDATE_URL = "/v1/slider/update";
const DELETE_URL = "/v1/slider/delete";

const SLIDER_API_URL_LIST = {
    LIST_URL,
    SINGLE_URL,
    ADD_URL,
    UPDATE_URL,
    DELETE_URL
}

export { SLIDER_API_URL_LIST };